import { render, staticRenderFns } from "./predict.vue?vue&type=template&id=eac85bee&scoped=true&"
import script from "./predict.vue?vue&type=script&lang=js&"
export * from "./predict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac85bee",
  null
  
)

export default component.exports